import React from 'react';
import styles from '../../styles/GruposStyles/PantallaDeGrupos.module.css';
import { usePermissions } from '../../hooks/usePermissions';

const ActionButtons = ({ group, onView, onEdit, onDelete }) => {
  const { canEdit, canDelete } = usePermissions();
  const puedeEditar = canEdit('Perfil Académico');
  const puedeEliminar = canDelete('Perfil Académico');

  return (
    <div className={styles.actionButtonsContainer}>
      <img
        src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/e054564ed1bcb4be6d0f8968ecf39fd825a798c5?placeholderIfAbsent=true"
        alt="Ver detalles"
        className={styles.actionButton}
        onClick={() => onView && onView(group)}
      />
      {puedeEditar && (
        <img
          src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/a03a9a16af0d11e1982fced03460e479acbb5851?placeholderIfAbsent=true"
          alt="Editar"
          className={styles.actionButton}
          onClick={() => onEdit && onEdit(group)}
        />
      )}
      {puedeEliminar && (
        <img
          src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/98cae3bdddd3b7d51cf234a8e61559e5ad2f1cfc?placeholderIfAbsent=true"
          alt="Eliminar"
          className={styles.actionButton}
          onClick={() => onDelete && onDelete(group)}
        />
      )}
      {!puedeEditar && !puedeEliminar && (
        <span style={{ color: '#888', fontSize: '12px' }}>Solo lectura</span>
      )}
    </div>
  );
};

export default ActionButtons;
